export default __webpack_public_path__ + "static/media/planets.1800005b.png";